// CategoryList.js
import React from "react";
import PropTypes from "prop-types";
import CategoryListItem from "../CategoryListItem";
import styles from "./CategoryList.module.css";

export function CategoryList({
  categories,
  onDelete,
  onChevronClick,
  onSave,
  isInModal,
}) {
  const handleDeleteClick = (category) => {
    const listId = category?.listId ?? category?.setId;
    onDelete?.(listId);
  };

  const handleRowClick = (category) => {
    onChevronClick?.(category);
  };

  return (
    <div className={`${styles.container} ${isInModal ? styles.inModal : ""}`}>
      {categories.map((category) => {
        const chevronHandler =
          typeof onChevronClick === "function"
            ? () => onChevronClick(category)
            : undefined;

        return (
          <div
            key={category.listId ?? category.setId ?? category.name}
            className={styles.categoryItem}
          >
            <CategoryListItem
              category={category}
              isNew={category.isNew}
              isModal={category.isModal}
              isInModal={isInModal}
              onClick={() => handleRowClick(category)}
              onDelete={() => handleDeleteClick(category)}
              onSave={onSave}
              onChevronClick={chevronHandler}
            />
          </div>
        );
      })}
    </div>
  );
}

CategoryList.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      listId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      setId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      stocks: PropTypes.arrayOf(
        PropTypes.shape({
          stockId: PropTypes.number,
          order: PropTypes.number,
        })
      ),
      type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      isNew: PropTypes.bool,
      isModal: PropTypes.bool,
      isInModal: PropTypes.bool,
      isSystemList: PropTypes.bool,
      isNavigable: PropTypes.bool,
      isAlreadyInList: PropTypes.bool,
    })
  ),
  onChevronClick: PropTypes.func,
  onSave: PropTypes.func,
};
